import { render, staticRenderFns } from "./createTrip.vue?vue&type=template&id=7a0b8b4e&"
import script from "./createTrip.vue?vue&type=script&lang=js&"
export * from "./createTrip.vue?vue&type=script&lang=js&"
import style0 from "./createTrip.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports